import IconCross from "@common/components/icons/IconCross";
import AccordionControlLink from "@common/components/thirdParty/mantine/accordion/AccordionControlLink";
import AccordionSection from "@common/components/thirdParty/mantine/accordion/AccordionSection";
import { persistUTMQueryParamsToString } from "@common/utils/router";
import { useRouter } from "next/router";
import { ReactElement } from "react";
import { IPurchaseCardProps } from "../../types";

export default function CancelSubscriptionSection({
  purchase,
}: Pick<IPurchaseCardProps, "purchase">): ReactElement {
  const router = useRouter();

  const { id, hosted_instance } = purchase;
  const title = hosted_instance
    ? "Cancel subscription and delete instance"
    : "Cancel subscription";

  return (
    <AccordionSection>
      <AccordionControlLink
        icon={<IconCross />}
        title={title}
        href={persistUTMQueryParamsToString(router, `/account/${id}/cancel`)}
      />
    </AccordionSection>
  );
}
